import React from 'react';
import { FONTS } from 'styles/theme';
import { SwitchProfileButton } from 'components/auth/AuthActions';

// Full-bleed banner (rendered outside the page's centred column). Text sits in a
// padded inner block so it lines up with the content below instead of running to
// the window edge.
const MealPlanHeader = ({ customer }) => (
    <>
        <div style={{
            backgroundImage: 'url("/header-bg.jpg")',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            position: 'relative',
            minHeight: 'clamp(200px, 26vh, 300px)',
            display: 'flex',
            alignItems: 'center',
            marginBottom: '28px'
        }}>
            {/* Darkening overlay for text contrast. Was a flat 60% black, which
                muddied the food photography; this matches the homepage hero and
                is weighted to the left so the text stays legible. */}
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'linear-gradient(90deg, rgba(30,28,26,0.62) 0%, rgba(30,28,26,0.45) 55%, rgba(30,28,26,0.28) 100%)',
                zIndex: 1
            }} />
            <div style={{
                position: 'relative',
                zIndex: 2,
                width: '100%',
                maxWidth: '1320px',
                margin: '0 auto',
                padding: '0 clamp(20px, 4vw, 40px)',
                boxSizing: 'border-box'
            }}>
                <h1 style={{
                    margin: '0 0 4px 0',
                    color: '#ffffff',
                    fontFamily: FONTS.serif,
                    fontWeight: 700,
                    lineHeight: 1.1,
                    fontSize: 'clamp(28px, 5vw, 52px)'
                }}>
                    Square Fare
                </h1>
                <h1 style={{
                    margin: '0 0 14px 0',
                    color: '#ffffff',
                    fontFamily: FONTS.serif,
                    fontWeight: 700,
                    lineHeight: 1.1,
                    fontSize: 'clamp(20px, 4vw, 42px)'
                }}>
                    Personalized Meal Plan
                </h1>
                <p style={{
                    margin: 0,
                    color: '#ffffff',
                    fontFamily: FONTS.sans,
                    fontWeight: 700,
                    fontSize: 'clamp(12px, 2vw, 18px)',
                    wordBreak: 'break-word'
                }}>
                    {customer.name} • {customer.email}
                </p>
                <SwitchProfileButton style={{ color: '#ffffff', fontFamily: FONTS.sans, fontSize: 'clamp(12px, 1.6vw, 15px)', marginTop: '8px' }} />
            </div>
        </div>
    </>
);

export default MealPlanHeader;
